import React, { useState, useEffect } from "react"
import { Box, IconButton, Flex, Button } from "@chakra-ui/react"
import Icon from "@app/components/Icon"
import { useNewsletter } from "@app/hooks/useNewsletter"
import type { Location } from "@root/types/global"
import { useAnalytics } from "@app/hooks/useAnalytics"

type SubscribeSideWidgetProps = {
  location: Location
  setOpen: (open: boolean) => void
}

export function SubscribeSideWidget({ setOpen, location }: SubscribeSideWidgetProps) {
  const {
    newsletter: { enableSubscriptionWidget, subscriptionWidgetTitle },
    activeTab,
  } = useNewsletter(location)
  const [showWidget, setShowWidget] = useState(activeTab)

  useEffect(() => {
    setShowWidget(activeTab)
  }, [activeTab])

  const { trackSubscriptionPopupClick } = useAnalytics()

  const handleWidgetClick = () => {
    trackSubscriptionPopupClick()
    setOpen(true)
  }

  return (
    <>
      {enableSubscriptionWidget && showWidget && (
        <Box position="fixed" left="0" right="auto" bottom="25%" zIndex={999}>
          <Flex gap={0.5} transform="rotate(-90deg)" transformOrigin="0 0">
            <IconButton
              minW={7}
              minH={7}
              width={7}
              height={7}
              aria-label="Close sign up tab"
              icon={<Icon name="closeSmallCircle" width={7} height={7} />}
              onClick={() => setShowWidget(false)}
              position="absolute"
              borderRadius="100%"
              right="-15px"
              bottom="-15px"
              backgroundColor="primary.white"
              zIndex={999}
            />
            <Button w={21} h={9} px={0} py={0} onClick={handleWidgetClick} variant="primary" size="small" borderRadius={0} _hover={""}>
              {subscriptionWidgetTitle}
            </Button>
          </Flex>
        </Box>
      )}
    </>
  )
}
